import FitAssistantStatus from '../Enums/FitAssistantStatus.ts';
import { CarInformation, Translations } from '../Types/FitAssistantData.ts';

export class ButtonHelper {
  public static GetSelectionText(
    fitStatus: FitAssistantStatus,
    carInformation: CarInformation[],
    translations: Translations,
    isProductPage: boolean
  ): string {
    if (!translations) return '';
    switch (fitStatus) {
      case FitAssistantStatus.NoSelection:
        return isProductPage ? translations.confirmVehicleFit : translations.bannerNoSelection;
      case FitAssistantStatus.Confirmed:
      case FitAssistantStatus.Unconfirmed:
      case FitAssistantStatus.NoFit:
        return this.GetCarInformationBtnText(carInformation);
      case FitAssistantStatus.RackMounting:
        return translations.rackMounting;
      default:
        return '';
    }
  }

  public static GetStatusLabel(fitStatus: FitAssistantStatus, translations: Translations): string {
    let label = '';
    switch (fitStatus) {
      case FitAssistantStatus.NoSelection:
        label = translations.seeFits;
        break;
      case FitAssistantStatus.Confirmed:
      case FitAssistantStatus.RackMounting:
        label = translations.confirmed;
        break;
      case FitAssistantStatus.Unconfirmed:
        label = translations.unconfirmed;
        break;
      case FitAssistantStatus.NoFit:
        label = translations.noFit;
        break;
    }
    return label;
  }

  private static GetCarInformationBtnText(carInformation: CarInformation[]): string {
    if (carInformation && carInformation.length >= 3)
      return carInformation[0].text + ' ' + carInformation[1].text + ' ' + carInformation[2].text;
    return '';
  }

  public static HandleStickyButtonOnScroll(
    buttonRef: React.RefObject<HTMLDivElement>,
    setIsSticky: React.Dispatch<React.SetStateAction<boolean>>
  ): void {
    if (!buttonRef.current) return;

    const siteHeader = document.getElementById('REACT_siteHeader');
    if(!siteHeader) return;

    const headerHeight = siteHeader.getBoundingClientRect().height || 0;
    const headerIsSticky = siteHeader.querySelector('.siteHeader_wrapper.sticky');
    const rect = buttonRef.current.getBoundingClientRect();
    const shouldBeSticky = rect.top < (headerIsSticky ? headerHeight : 0);
    setIsSticky((prev) => {
      if (prev !== shouldBeSticky) {
        return shouldBeSticky;
      }
      return prev;
    });

    if (shouldBeSticky) siteHeader.querySelector('.siteHeader_wrapper')?.classList.add('collapsed');
  }
}